import React from 'react'
import { Link } from 'gatsby'
import { shape, string, arrayOf } from 'prop-types'
import { css } from '@emotion/react'

import Icon from '../Icon'

const iconCss = ({ colors }) => css`
  fill: ${colors.rose};

  svg {
    margin-right: 10px;
    margin-top: -4px;
    color: ${colors.rose};
    width: 24px;
    height: 24px;
  }
`

const FeaturedCategories = ({ categories, className }) => {
  if (!categories) {
    return null
  }

  return (
    <ul className={className}>
      {categories.map((item) => (
        <Link
          key={`feature-${item.label}`}
          to={item.url}
          activeClassName="active-link"
        >
          <Icon label={item.label} css={iconCss} />
          <span>{item.label}</span>
        </Link>
      ))}
    </ul>
  )
}

FeaturedCategories.propTypes = {
  categories: arrayOf(
    shape({
      label: string,
      url: string,
    })
  ),
  className: string,
}

export default FeaturedCategories
